


















import Vue from 'vue'

export default Vue.extend({
  name: 'UpdatePhotoDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('closeUpdatePhotoDialog')
    },

    onPhotoUpdateClick (): void {
      this.$emit('photoUpdate')
    },

    onPhotoRemoveClick (): void {
      this.$emit('photoRemove')
    }
  }
})
